import sortCategoryData from '../utils/sortCategoryData'

// generates series data for violin plots
// returns an array where each element represents a category with its numeric values
export default function generateViolinSeries(settings) {
  // Return empty array if no categories are selected
  if (
    settings.chartSpecificOptions.categoriesSelectedX.length === 0 ||
    settings.chartSpecificOptions.categoriesSelectedY.length === 0
  ) {
    return []
  }

  const xAxis = settings.chartSpecificOptions.xAxis
  const yAxis = settings.chartSpecificOptions.yAxis
  const data = settings.data

  const categoriesSelectedY = sortCategoryData(
    settings.chartSpecificOptions.categoriesSelectedY
  )

  const series = []

  categoriesSelectedY.forEach((category) => {
    const values = []
    const variables = []

    data.forEach((item) => {
      if (item[yAxis] === category) {
        const v = parseFloat(item[xAxis])
        if (!isNaN(v)) {
          values.push(v)
          variables.push(item)
        }
      }
    })

    if (values.length > 0) {
      series.push({ name: category, data: values, variables })
    }
  })

  return series
}
